import ModulePage from './ModulePage'

export default ModulePage;